export default __webpack_public_path__ + "static/media/modelcube-white.16917f6f.svg";